import React from 'react';
import Careers from '../Components/Job/Careers';
import CareerSection from '../Components/Job/CareerSection';
import OffersSection from '../Components/Job/OffersSection';
import Footer from '../Components/Footer';

const Jobs = () => {
    return (
      <div>
        <Careers />
        <CareerSection/>
        <OffersSection/>
        <Footer />
      </div>
    );
  }
  export default Jobs; 